import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import {School} from "models"
/**
 * @typedef {object} ComponentsSchoolsLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} school
 * @property {unknown} superAdminLayout
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsSchoolsLinkState */

/**
 * @extends {ShapeComponent<ComponentsSchoolsLinkProps, ComponentsSchoolsLinkState>}
 */
class ComponentsSchoolsLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    superAdminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    school: PropTypes.instanceOf(School).isRequired,
    superAdminLayout: PropTypes.bool.isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, school, superAdminLayout, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--schools--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || school.displayName()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || school.displayName()}
      </span>
    )
  }

  to() {
    const {adminLayout, school, superAdminLayout} = this.p

    if (adminLayout) {
      return Routes.adminSchoolPath(school.id())
    } else if (superAdminLayout) {
      return Routes.superAdminPath({model: "School", model_id: school.id()})
    }

    return "#"
  }
}

export default memo(shapeComponent(ComponentsSchoolsLink))
